import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import logoAO from "./../Images/logo_small.png";
import Grid from '@material-ui/core/Grid';
import FreeTrial from './FreeTrial';
import css from './../Views/AOSalesView.module.css';
import cssCommon from './../Views/Common.module.css';


class AOSalesView extends Component {
  constructor(props) {
    super(props);  

    this.state ={
      Sales_Name: props.data.Login.FirstName + " " + props.data.Login.LastName
    }
  }

  render() {
    return (
      <div>
        <Paper className={css.paper} elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <img src={logoAO} alt="logo" className={css.logo}></img>
            </Grid>
            <Grid item xs={2}>
              <div className={css.label}>Free Trial View</div>
            </Grid>
            <Grid item xs={5}>
              
            </Grid>
            <Grid item xs={3}>
              <div className={css.label}>{this.state.Sales_Name}</div>
            </Grid>
          </Grid>
          <div className={cssCommon.separator}></div>
          <FreeTrial data={this.props.data}></FreeTrial>
        </Paper>
      </div>
    );
  }
}

export default AOSalesView;